export class Constant {

    public static isProduction = process.env.VUE_APP_NODE_ENV === 'production';


    public static BASE_URL = "";
    // public static PLATFORM_URL = "http://192.168.10.5/platform/";
    // public static PLATFORM_URL = "https://nationaltrainingweek.gov.my/";
    // public static SWV1_URL = "http://192.168.10.42/swv1/public/api/";
    //public static SWV1_URL = "https://core.nationaltrainingweek.gov.my/api/api/";
    // public static SERVER_URL = "http://192.168.10.42/hrdfrest/public/";
    // public static SERVER_URL = "https://nationaltrainingweek.gov.my/api/";
    //public static SERVER_URL = window.location.origin+"/api/";
    // public static PLATFORM_URL = "https://nationaltrainingweek.gov.my/";
    
    //yusri
    public static PLATFORM_URL = Constant.isProduction ? "https://nationaltrainingweek.gov.my/" : "http://192.168.10.5/platform/";
    // public static SWV1_URL = "http://192.168.10.42/swv1/public/api/";
    // public static SWV1_URL = Constant.isProduction ? "https://core.nationaltrainingweek.gov.my/api/api/" : "http://192.168.10.42/swv1/public/api/";
    public static SWV1_URL = Constant.isProduction ? "https://core.nationaltrainingweek.gov.my/api/api/" : "/platform/api/swv1/public/api/";
    // public static SERVER_URL = "http://192.168.10.42/hrdfrest/public/";
    // public static SERVER_URL = "https://nationaltrainingweek.gov.my/api/";
    // public static SERVER_URL = window.location.origin+"/api/";
    // public static SERVER_URL = window.location.protocol + "//" + window.location.host + "/";
    // public static SERVER_URL = Constant.isProduction ? window.location.origin+"/api/" : "http://192.168.10.42/hrdfrest/public/";
    public static SERVER_URL = Constant.isProduction ? window.location.origin+"/api/" : "/platform/api/hrdfrest/public/";
    //end yusri
    
    // public static SERVER_URL = "http://ntw-backend.test/";

    public static SERVER_URL_WITH_API = Constant.SERVER_URL + "api/";
    // public static upskill_url="http://192.168.10.27/core/";
    public static upskill_url= Constant.isProduction ? "https://core.nationaltrainingweek.gov.my/" : "http://192.168.10.27/core/";
    //public static upskill_url="http://http://localhost:8081/";
    public static ACTIVE="ACTIVE";
    public static INACTIVE="IN-ACTIVE";
    public static DE_ACTIVE="DE-ACTIVE";
    public static DENIED="DENIED";
    public static ADMIN_CLIENT_ID = "6";
    //local
// public static ADMIN_CLIENT_SECRETKEY = "9GDWrxZdiVXLRMIeKIFpDGIJQQHruwDpU1J3zEaY";

    //prod
    public static ADMIN_CLIENT_SECRETKEY = "jLhdG89kfFqzmmdZhPTnFSV7BMpirrFYyy6OOj0s";

    public static ADMIN_PROVIDER = "admins";
    public static EMPLOYER_PROVIDER = "employers";
    public static JOBSEEKER_PROVIDER = "jobseekers";
    public static APPLIED = "APPLIED";
    public static ACCEPTED = "ACCEPTED";
    public static COMPLETED = "COMPLETED";
    public static REJECTED = "REJECTED";
    public static APPROVED = "APPROVED";
    public static SCHEDULED = "SCHEDULED";
    public static HIRED = "HIRED";
    public static NOT_HIRED = "NOT HIRED";
    public static SCHEDULED_ACCEPTED = "SCHEDULED ACCEPTED";
    public static SCHEDULED_REJECTED = "SCHEDULED REJECTED";
    public static EMPLOYER_ROLE = "EMPLOYER";
    public static SUBMITTED = "SUBMITTED";
    public static UPDATED = "UPDATED";
    public static OSSReplaceURL = "https://ntw-prod.oss-ap-southeast-3.aliyuncs.com";
    public static OSSInternalURL = "http://ntw-prod.oss-ap-southeast-3.aliyuncs.com";
    // public static OSSInternalURL = "http://ntw-prod.oss-ap-southeast-3-internal.aliyuncs.com";
    public static JOBSEEKER_ROLE="JOBSEEKER";
    public static EMPLOYEE_ROLE="EMPLOYEE";
    public static FOLLOWING="FOLLOWING";
    public static UNFOLLOW="UNFOLLOW";
    public static PENDING="PENDING";
    public static AD_LIMIT=8;
    public static upskill_login_url= Constant.upskill_url+"auth/loginhpc?token=";
    public static upskill_Mlogin_url= Constant.upskill_url+"auth/loginm";
    public static upskill_agency_login_url = Constant.upskill_url + "auth/login";
    public static Rtist_url = "https://www.rtist.com.my/";
    public static TheKedua_url = "https://www.thekedua.com/";
    public static googleLoginurl = Constant.SERVER_URL+"api/login/google";
    public static facebookLoginurl = Constant.SERVER_URL+"api/login/facebook";
    public static jobPostForSocialMediaUrl = Constant.SERVER_URL+"viewJobPostForSocialMedia/";
    public static option1 = "Existing Employees";
    public static option2 = "Entrepreneurship / Self-employment";
    public static config = {
        'messagingSenderId': '458030489647',
        'authDomain': "hrdf-fcm.firebaseapp.com",
        'apiKey': 'AIzaSyADPE39PcbyF7o8u2jnwcCCKrzKYttHziw',
        'storageBucket': "hrdf-fcm.appspot.com",
        'projectId': 'hrdf-fcm',
        'appId': '1:458030489647:web:57011a55195a228ca0e6da',
        'measurementId': "G-GK14YNZZ1Z",
    };
    // npm install --save nodent-runtime
    public static AES_ENCRYPTION_KEY="&J{cb6aP<aKL4nP+ED7a$c6BdgXw`g0M";
    public static ENCRYPT_IV="q6RzV,W$CT4UWeED";
}
